import * as React from "react"
import Svg, {Defs, LinearGradient, Path, Stop} from "react-native-svg"

export default function TableNumberBackground(props:any) {
    return (
        <Svg
            width={"100%"}
            height={"100%"}
            viewBox="0 0 99 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M99 10.896a2.993 2.993 0 01-2.846 2.992A969.757 969.757 0 0149.5 15c-15.904 0-31.492-.38-46.654-1.112A2.993 2.993 0 010 10.896V3a3 3 0 013-3h93a3 3 0 013 3v7.896z"
                fill="url(#paint0_linear_1478_6745)"
            />
            <Defs>
                <LinearGradient
                    id="paint0_linear_1478_6745"
                    x1={52.6935}
                    y1={-1.29311}
                    x2={49.7132}
                    y2={15.2682}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#00ED62" />
                    <Stop offset={1} stopColor="#00C853" />
                </LinearGradient>
            </Defs>
        </Svg>
    )
}

